<template>
  <section
    class="md:mt-8 m-auto bg-black pt-6 px-2 md:px-10 pb-5 shadow-black shadow-xl max-w-[1400px]"
  >
    <div
      id="message"
      class="h-[60vh] w-full text-white font-electro text-[24px] flex flex-col text-center pt-16 md:pt-4"
    >
      <div class="flex flex-col gap-4">
        <p v-if="token" class="uppercase text-[18px] py-4">Choose a new password</p>
        <input v-if="token" type="password" id="userPassword" placeholder="Enter Password" name="psw" required
          class="max-w-[250px] m-auto placeholder:text-[16px] text-black pl-2 placeholder:pl-2 rn-br"
          v-model="password" />
        <input v-if="token" type="password" id="userPasswordConfirmation" placeholder="Repeat Password" name="rpsw" required
          class="max-w-[250px] m-auto placeholder:text-[16px] text-black pl-2 placeholder:pl-2 rn-br"
          v-model="repeat_password" />
        <div v-if="token" class="flex flex-col gap-2">
          <p class="text-[16px]" v-if="password.length > 0">Password Strength: <span :class="{week: strength < 3, good: strength >= 3}">{{ strengthText }}</span></p>
          <p class="text-[14px]">Password must be at least 8 characters long, and contain a combination of lowercase & uppercase letters, numbers and/or symbols.</p>
        </div>
        
        <button v-if="passwordIsValid" @click="resetPassword()"
          class="bg-[#ff0000] max-w-[200px] mt-4 m-auto text-[18px] px-8 py-2 rn-br">
          Confirm
        </button>
        <p class="mt-4 m-auto text-[16px] rn-positive rn-br" v-if="result == 0">Password changed successfully</p>
        <p class="mt-4 m-auto text-[16px] rn-negative rn-br" v-if="result == 1">Something bad happened. Please try again
        </p>
        <p class="mt-4 m-auto text-[16px] rn-negative rn-br" v-if="result == 3">The reset link is either Invalid or has
          Expired.</p>
        <p class="mt-4 m-auto text-[16px] rn-negative rn-br" v-if="password != repeat_password && repeat_password.length > 0">Your passwords don't
          match!</p>
      </div>
    </div>
  </section>
  <section class="mt-8">
    <PartnersSmall partners-title="true" />
    <RallyLogoDownload link-text="Download Rally Navigator" />
  </section>
  <LoadingBar v-if="loading == true" message="Setting the new password..." />
</template>

<script>
import PartnersSmall from './PartnersSmall.vue';
import RallyLogoDownload from './RallyLogoDownload.vue';
import LoadingBar from './LoadingBar.vue';

export default {
  name: 'ResetPassword',
  components: {
    PartnersSmall,
    RallyLogoDownload,
    LoadingBar,
  },
  data() {
    return {
      result: -1,
      password: '',
      repeat_password: '',
      token: this.getURLParameter(),
      loading: false,
    };
  },
  mounted() {
    if (!this.token) {
      this.result = 3;
    }
  },
  computed: {
    passwordIsValid() {
      return this.password == this.repeat_password && this.strength >= 3 && this.password.length >= 8;
    },
    strength() {
      let score = 0;
      if (this.password.length >= 8) score++;
      if (this.password.match(/[a-z]/)) score++;
      if (this.password.match(/[0-9]/)) score++;
      if (this.password.match(/[A-Z]/)) score++;
      if (this.password.match(/[$@#&!]/)) score++;
      return score;
    },
    strengthText() {
      switch (this.strength) {
        case 0:
          return 'Weak';
        case 1:
          return 'Weak';
        case 2:
          return 'Weak';
        case 3:
          return 'Good';
        case 4:
          return 'Strong';
        case 5:
          return 'Very Strong';
        default:
          return 'Weak';
      }
    },
  },
  methods: {
    async resetPassword() {
      this.loading = true;
      const response = await fetch(
        "https://api.rallynavigator.com/api/v2/auth/update_password",
        {
          method: "POST",
          body: JSON.stringify({
            user: {
              password: this.password,
              password_confirmation: this.repeat_password,
              reset_token: this.token,
            },
          }),
          headers: {
            "Content-Type": "application/json",
            "x-api-key": "Rw987ENLxJZyzB17Y3IH2Teu94IDLXl5AfWRsU50",
          },
        }
      );
      this.loading = false;
      //console.log(response)
      if (!response.ok) {
        //unvalid or expired token
        this.result = 3;
        return
      }
      const result = await response.json();
      if (result.success === true) {
        this.result = 0;
      } else {
        switch (result.error_code) {
          case "0002":
            this.result = 1;
            //passwords don't match - validation on the backend - should never fall into this case
            break;
          default:
            this.result = 1;
            break;
        }
      }
    },
    getURLParameter() {
      return this.$route.query.q;
    },
  },

};
</script>

<style scoped>
.rn-positive {
  background-color: green;
  border: 3px solid lightgreen;
  padding: 10px;
  min-width: 300px;
}

.rn-negative {
  background-color: darkred;
  border: 3px solid red;
  padding: 10px;
  min-width: 300px;
}

.rn-br {
  border-radius: 4px;
}

.week {
  font-weight: bold;
  color: red;
}

.good {
  font-weight: bold;
  color: lightgreen;
}
</style>
